<template>
  <div class="tabbar">
    <el-menu
      :default-active="$route.path"
      router
      mode="horizontal"
      active-text-color="#0e9cf6"
    >
      <el-menu-item v-if="isOther" @click="goMain"> 返回我的空间</el-menu-item>
      <el-menu-item v-for="(item, i) in navList" :key="i" :index="item.name">{{
        item.navItem
      }}</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      navList: [
        { name: "/space/dynamic", navItem: "最新动态" },
        { name: "/space/glass", navItem: "班级圈" },
        { name: "/space/school", navItem: "学校圈" },
        { name: "/space/saying", navItem: "说说" },
        { name: "/space/journal", navItem: "日志" },
        { name: "/space/ablum", navItem: "相册" },
        { name: "/space/message", navItem: "留言板" },
        { name: "/space/collection", navItem: "收藏" },
      ],
      iteminfo: "",
      itemtext: "",
      isOther: false,
    };
  },
  created() {
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    this.itemtext = JSON.parse(window.localStorage.getItem("routerstate"));
    if (this.itemtext != "1") {
      this.navList = [
        { name: "/space/dynamic", navItem: "最新动态" },
        { name: "/space/saying", navItem: "说说" },
        { name: "/space/journal", navItem: "日志" },
        { name: "/space/ablum", navItem: "相册" },
        { name: "/space/message", navItem: "留言板" },
        { name: "/space/collection", navItem: "收藏" },
      ];
    }
    if (this.iteminfo) {
      this.isOther = true;
      this.navList = [
        { name: "/space/saying", navItem: "说说" },
        { name: "/space/journal", navItem: "日志" },
        { name: "/space/ablum", navItem: "相册" },
        { name: "/space/message", navItem: "留言板" },
      ];
      // console.log(this.navList);
    }
  },
  mounted() {},
  methods: {
    goMain() {
      localStorage.removeItem("iteminfo");
      this.$router.push("/space/dynamic");
    },
  },
};
</script>

<style lang="less">
.tabbar {
  margin-top: 20px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  height: 60px;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  opacity: 0.98;
  .el-menu--horizontal {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 800px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
  }

  .el-menu-item {
    font-size: 15px;
    color: #3c495c !important;
    border-bottom: none;
    // border-radius: 8px;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;
    background-color: rgb(77, 141, 231);
    color: #fff !important;
    // border-radius: 8px;
  }
}
</style>